import { FC } from 'react'
import { MainColumn, MultiColumns, SubColumn } from '@lifedot/layout'
import { PostList } from '@/components/PostList/PostList'
import { Banners } from '@lifedot/components/Banners'
import { postPage_indexQuery$data } from '@/queries/__generated__/postPage_indexQuery.graphql'
import { NotFound } from '@lifedot/components/NotFound'
import { postPagination_indexQuery$data } from '@/queries/__generated__/postPagination_indexQuery.graphql'
import { AreaLinkAccordions } from '@/components/AreaLinkAccordions/AreaLinkAccordions'
import { PostListCard } from '@/components/PostListCard/PostListCard'
import { AddMarginWrapper } from '@lifedot/components/AddMarginWrapper'
import { Breadcrumb } from '@/components/Breadcrumb/Breadcrumb'
import { PostStructuredData } from '@/components/StructuredData/PostStructuredData/PostStructuredData'

interface ListTemplateProps {
  data:
    | postPage_indexQuery$data
    | postPagination_indexQuery$data
    | null
    | undefined
}

export const ListTemplate: FC<ListTemplateProps> = ({ data }) => {
  if (!data?.post) return <NotFound />

  return (
    <>
      <PostStructuredData post={data.post} />
      <Breadcrumb {...data} />
      <MultiColumns>
        <MainColumn>
          <PostList posts={data.post.child_posts} post={data.post} />
        </MainColumn>
        <SubColumn>
          <AddMarginWrapper spacing={3}>
            <Banners />
            <AreaLinkAccordions />
            <PostListCard
              posts={data.newlyCemeteryPosts}
              header="お墓の新着記事"
            />
            <PostListCard posts={data.newlyPosts} header="新着記事" />
          </AddMarginWrapper>
        </SubColumn>
      </MultiColumns>
    </>
  )
}
